import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function authConfig() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function listTransactions(params = {}) {
  const res = await axios.get(`${API_URL}/api/finance/transactions`, {
    ...authConfig(),
    params
  });
  return res.data;
}

export async function getTransactionDetail(queueId) {
  const res = await axios.get(
    `${API_URL}/api/finance/transactions/${encodeURIComponent(queueId)}`,
    authConfig()
  );
  return res.data;
}

export async function getTransactionsSummary(params = {}) {
  const res = await axios.get(`${API_URL}/api/finance/transactions/summary`, {
    ...authConfig(),
    params
  });
  return res.data;
}

export async function getChartOfAccounts() {
  const res = await axios.get(`${API_URL}/api/finance/transactions/accounts`, authConfig());
  return res.data;
}

export async function voidDuplicate(queueId, body = {}) {
  const res = await axios.post(
    `${API_URL}/api/finance/transactions/${encodeURIComponent(queueId)}/void-duplicate`,
    body,
    authConfig()
  );
  return res.data;
}

export async function restoreDuplicate(queueId, jeId) {
  const res = await axios.post(
    `${API_URL}/api/finance/transactions/${encodeURIComponent(queueId)}/restore-duplicate`,
    { je_id: jeId },
    authConfig()
  );
  return res.data;
}

const transactionsService = {
  listTransactions,
  getTransactionDetail,
  getTransactionsSummary,
  getChartOfAccounts,
  voidDuplicate,
  restoreDuplicate
};

export default transactionsService;
